/** Map plan IDs to display names (API often returns plan_id but not plan_title). */
export const PLAN_DISPLAY_NAMES = {
  "workspace-starter-yearly": "Starter",
  "workspace-professional-seats-yearly": "Professional Yearly",
  "workspace-professional-seats-monthly": "Professional Monthly",
  "workspace-business-seats-yearly": "Business Yearly",
  "workspace-business-seats-monthly": "Business Monthly",
  "workspace-team-seats-yearly": "Team Yearly",
  "workspace-team-seats-monthly": "Team Monthly",
  "workspace-individual-seats-yearly": "Individual Yearly",
  "workspace-individual-seats-monthly": "Individual Monthly",
  "workspace-seats-yearly": "Seats Yearly",
  "workspace-enterprise-seats-yearly": "Enterprise Yearly",
};

/**
 * @param {string} [planTitle]
 * @param {string} [planId]
 * @returns {string}
 */
export function getPlanDisplayName(planTitle, planId) {
  if (planId && PLAN_DISPLAY_NAMES[planId]) return PLAN_DISPLAY_NAMES[planId];
  const base = planTitle && !planTitle.startsWith("workspace-") ? planTitle : planTitle || planId || "Free";
  if (planId) {
    if (planId.includes("-yearly")) return `${base} (Yearly)`;
    if (planId.includes("-monthly")) return `${base} (Monthly)`;
  }
  return base;
}
